import { useMutation } from "@tanstack/react-query";
import { NotificationsLevel } from "../../../lib/enums";
import { show } from "../../../notifications/notifications";
import { ErrorResponse, MessageErrorResponse } from "../../../requests/@types";
import api from "../api";

type Request = {
  sha1: string;
};

const useReleaseFromQuarantine = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ sha1 }: Request) => api.releaseFromQuarantine(sha1),
    onSuccess: () => {
      show({
        level: NotificationsLevel.SUCCESS,
        message: "Email was successfully released from the quarantine."
      });
    },
    onError: ({ data }: ErrorResponse<MessageErrorResponse>) => {
      show({
        level: NotificationsLevel.ERROR,
        message: data?.message ?? "Failed to release email from quarantine."
      });
    }
  });

  return { release: mutateAsync, isPending };
};

export default useReleaseFromQuarantine;
